import { RouterView } from "vue-router";

export const manufacturersRoute = {
  path: ":menu/manufacturers",
  component: <RouterView />,
  children: [
    {
      path: "",
      component: () => import("@/views/manufacturers/list/index.vue"),
    },
    {
      path: ":type-sellers",
      component: () => import("@/views/sellers/list/index.vue"),
    },
    {
      path: "clients",
      component: () => import("@/views/clients/list/index.vue"),
    },
    {
      path: "clients/:userId/devices",
      component: () => import("@/views/devices/list/index.vue"),
    },
  ],
};
